// Phase 3.1d: antd/MUI/FA fully removed from this screen; image/video pick
// guards now use the app's Sonner toast.
import { toast } from "sonner"
import AppConstant from "../Globals/AppConstants"
import ApparelMenu from "./SubComponents/apparelMenu"
import InventoryToolbar from "./inventory/InventoryToolbar" // Phase 3.1d: shadcn stocks toolbar (replaces ApparelSubmenu here)
import { useEffect, useRef, useState } from "react"
import { useLocation, useSearchParams } from "react-router-dom"
import { deepCopyFunction, isArrayEmpty, isArrayNotEmpty, toMb } from "../Utils/helpers"
import { useDispatch, useSelector } from "react-redux"
import {
    addProductAction, categoryAndSubCategoryListAction, createOrUpdateAttachmentAction, cycleCountListSearchAction,
    getAttachmentAction,
    getCoreCategoryMetaAction,
    getMultipleInventoryCountsAction, getMultipleInventoryDamagedListAction,
    getMultipleInventoryScrapListAction, getMultipleInventorySoldListAction, getProductHistoryAction,
    getProductListAction, getReferenceDataAction, updateMultipleInventoryAction,
    updateProductItemColorAndSizeAction, updateProductStatusAction, updateStickeringStatusAction,
    vendorDropDownListAction, mrpListAction, adminAdjustStockAction, getStockHistoryAction, getComboItemsAction
} from "../Store/actions/apparelAction"
import moment from "moment"
import BarCode from "./barCode"
import { LoadingOverlay } from "../shared/loading-overlay"
import { deleteFileFromS3, uploadPhotoToAWS } from "./SubComponents/awsUpload"
import InventoryStockTable from "./inventory/InventoryStockTable" // Phase 3.1a: shadcn table (presentation only)
import AddProductSheet from "./inventory/AddProductSheet" // Phase 3.1b: shadcn add/edit-product form
import ProductHistorySheet from "./inventory/ProductHistorySheet" // Phase 3.1c: history drawer -> Sheet
import MultiInventorySheet from "./inventory/MultiInventorySheet" // Phase 3.1c: product details drawer -> Sheet
import AttachmentSheet from "./inventory/AttachmentSheet" // Phase 3.1c: attachment drawer -> Sheet + FileDropzone




// Phase 3.1b: subCategory options are now derived inside AddProductSheet from
// categoryAndSubCategoryList; the module-level mutable list is no longer needed.

const InventoryManagement = () => {
    const dispatch = useDispatch();
    const [addProductbtDisabled, setAddProductbtDisabled] = useState(false);
    const [open, setOpen] = useState(false);
    const [page, setPage] = useState(1);
    const [product, setProduct] = useState<any>();
    const [barcodeOpen, setBarcodeOpen] = useState(false);
    const [modalOpen, setModalOpen] = useState(false)
    const [checkBoxRTV, setCheckBoxRTV] = useState(0)
    const [scrapData, setScrapData] = useState<any>(null)
    const apparelReducerState: any = useSelector((state: any) => state.ApparelReducerState);
    const [updateProduct, setUpdateProduct] = useState(false);
    const [spinnerLoad, setSpinnerLoad] = useState(false);
    const [productData, setProductData] = useState<any>(null);
    // Row being copied: the Add Stock sheet opens pre-filled from it (productData
    // stays null, so it is still an Add — nothing is saved until Save is clicked).
    const [copySource, setCopySource] = useState<any>(null);
    const [productDetailsClose, setProductDetailsClose] = useState(false);
    const [arrayStatus, setArrayStatus] = useState(0);
    const [updateSpinner, setUpdateSpinner] = useState(false)
    const [imgList, setImgList] = useState<any>([]);
    const [showAttachment, setShowAttachment] = useState<Boolean>(false);
    const [imgFileUuid, setImgFileUuid] = useState<String>('')
    const [singleImg, setSingleImg] = useState<any>(null)
    const [addCoverImage, setAddCoverImage] = useState(false)
    const [imageUpload, setImageUpload] = useState(false)
    const [showVideoAttachment, setVideoShowAttachment] = useState(false)

    const { categoryAndSubCategoryData,
        addProductOnload,
        productListData,
        updateProductStatusOnload,
        updateProductColorAndSizeOnload,
        updateStickeringStatusOnload,
        colorReferenceData,
        sizeReferenceData,
        getProductHistoryOnload,
        getProductHistoryData,
        getMultipleInventoryCountData,
        getMultipleInventorySoldData,
        getMultipleInventoryDamagedData,
        getMultipleScrapListData,
        updateMultipleInventory,
        productListOnload,
        genVendorDropDownListData,
        getMrpListData,
        getAttachmentLoad,
        getAttachmentData, createOrUpdateAttachmentLoad,
        getCoreCategoryData,
        adminAdjustStockLoad,
        adminAdjustStockData,
        addProductResult,
        getComboItemsData,
        getComboItemsFor,
        getStockHistoryData } = apparelReducerState;

    const getVendorDropDownList = genVendorDropDownListData?.getVendorDropDownList;
    const mrpList = getMrpListData?.getMrpList;
    const productHistoryData = getProductHistoryData?.getProductHsitory;
    const getHistoryDate = Object.keys(productHistoryData ? productHistoryData : "");

    const productList = productListData?.getProductList?.productItemDetails;
    const productListPage = productListData?.getProductList?.page;
    const categoryAndSubCategoryList = categoryAndSubCategoryData?.getCategoryList;
    const getMultipleInventoryCounts = getMultipleInventoryCountData?.getMultipleInventoryCounts;
    let getMultipleInventory_soldList: any;
    if (getMultipleInventorySoldData?.getMultipleInventory_soldList != undefined) {
        getMultipleInventory_soldList = getMultipleInventorySoldData?.getMultipleInventory_soldList[0];
    }
    const getMultipleInventory_damagedList = Array.isArray(getMultipleInventoryDamagedData?.getMultipleInventory_damagedList)
        ? getMultipleInventoryDamagedData?.getMultipleInventory_damagedList : [];
    const getMultipleInventory_ScrapList = Array.isArray(getMultipleScrapListData?.getMultiple_inventoryScrapList)
        ? getMultipleScrapListData?.getMultiple_inventoryScrapList : [];
    const stockAdjustmentList = Array.isArray(getStockHistoryData?.getStockHistory?.rows)
        ? getStockHistoryData?.getStockHistory?.rows : [];
    const getAttachmentListImage = isArrayNotEmpty(getAttachmentData?.getAttachement) ? getAttachmentData?.getAttachement[0]?.image : [];
    const getAttachmentListVideo = isArrayNotEmpty(getAttachmentData?.getAttachement) ? getAttachmentData?.getAttachement[0]?.video : [];

    const categoryList: any = [];
    const [productStatusOnload, setProductStatusOnload] = useState(false);
    const [changeColorStatusOnload, setChangeColorStatusOnload] = useState(false);
    const [createProductOnload, setCreateProductOnload] = useState(false);
    const [stickerStatusOnload, setStickerStatusOnload] = useState(false);
    const [productHistoryOnload, setProductHistoryOnload] = useState(false);
    const colorList = colorReferenceData?.getReferenceData;
    const sizeList = sizeReferenceData?.getReferenceData;
    const [historyData, setHistoryData] = useState<any>();
    const [completedSticker, setCompletedSticker] = useState(false);
    const [downloadSticker, setDownloadSticker] = useState(false);
    const [addDamagedStatus, setAddDamagedStatus] = useState(false);
    const [addScrapStatus, setAddScrapStatus] = useState(false);//this needs to be done after Api binding
    const [multiInventoryProduct, setMultiInventoryProduct] = useState<any>();
    const [modalDamaged, setModalDamaged] = useState(false)
    const [collapse, setCollapse] = useState<any>(['1'])
    const [damagedCollapse, setDamagedCollapse] = useState<any>(['1'])
    const [scrapCollapse, setScrapCollapse] = useState<any>(['1'])
    const [stockAdjustmentCollapse, setStockAdjustmentCollapse] = useState<any>(['1'])
    const [checkRecords, setCheckRecords]: any = useState([]);
    const [instockSticker, setInstockSticker] = useState(false);
    const [selectAllModal, setselectAllModal] = useState(false);
    const [attacmentDrawer, setAttachmentDrawer] = useState(false);
    const [attachmentEntityId, setAttachmentEntityId] = useState(null);
    const [videoList, setVideoList] = useState<any>([])

    const searchtemp: any = {
        searchText: "",
        offset: 0,
        limit: 10,
        page: 1,
        filterStatus: "",
        mrp: "",
        vendorId: "",
        categoryId: "",
        subCategoryId: "",
        stockType: ""
    };

    const [searchParams] = useSearchParams();
    const location = useLocation();
    // Arriving from Audit Log: re-run this screen's own search with the
    // record's business code, then open its edit Sheet once the matching
    // row (by productDetailsId, the uniqueKey alias) shows up in the list.
    const [pendingAuditRecordId, setPendingAuditRecordId] = useState<string | undefined>(location.state?.auditRecordId);
    const [filterData, setFilterData] = useState<any>(() => {
        const productIdParam = searchParams.get("productId") || location.state?.auditSearchCode;
        return productIdParam ? { ...deepCopyFunction(searchtemp), searchText: productIdParam } : deepCopyFunction(searchtemp);
    });
    const getsearchTextdataList = (searchText: any) => {
        setFilterData({ ...filterData, searchText: searchText, offset: 0, page: 1 })
    }

    const getFilterStatusdataList = (filterStatus: any) => {
        setFilterData({ ...filterData, filterStatus: filterStatus, offset: 0, page: 1 })
    }

    const getMrpFilterdataList = (mrp: any) => {
        setFilterData({ ...filterData, mrp: mrp, offset: 0, page: 1 })
    }

    const getVendorFilterdataList = (vendorId: any) => {
        setFilterData({ ...filterData, vendorId: vendorId, offset: 0, page: 1 })
    }

    const getCategoryFilterdataList = (categoryId: any) => {
        // Changing category invalidates any previously selected sub-category.
        setFilterData({ ...filterData, categoryId: categoryId, subCategoryId: "", offset: 0, page: 1 })
    }

    const getSubCategoryFilterdataList = (subCategoryId: any) => {
        setFilterData({ ...filterData, subCategoryId: subCategoryId, offset: 0, page: 1 })
    }

    const getStockTypeFilterdataList = (stockType: any) => {
        setFilterData({ ...filterData, stockType: stockType, offset: 0, page: 1 })
    }

    const handlePagination = (page: any, offset: any) => {
        setFilterData({ ...filterData, page: page, offset: offset })
    }

    // DataTable gives a 1-based page; reuse the legacy InventoryToolbar.goToPage
    // offset math (now rendered at the bottom of the table, like every other
    // migrated screen, instead of the toolbar's top-row prev/next controls).
    const onPageChange = (nextPage: number) => {
        const offset = nextPage * 10 - 10 <= 0 ? 0 : nextPage * 10 - 10;
        handlePagination(page, offset);
    }

    {
        (categoryAndSubCategoryList || []).map((item: any) => {
            let obj = {
                categoryId: item?.categoryId,
                categoryName: item?.categoryName
            }
            categoryList?.push(obj);
        })
    }


    const getReferenceDataApi = (ref: any) => {
        let payload: any = {
            referenceGroupId: ref
        }
        dispatch(getReferenceDataAction(payload));
    }
    const getProductListApi = () => {
        let payload = {
            searchText: filterData?.searchText,
            statusRefId: filterData?.filterStatus,
            mrp: filterData?.mrp,
            vendorId: filterData?.vendorId,
            categoryId: filterData?.categoryId,
            subCategoryId: filterData?.subCategoryId,
            stockType: filterData?.stockType,
            limit: 10,
            offset: filterData?.offset
        }
        dispatch(getProductListAction(payload))
    }

    const getWithoutSoldProductListApi = () => {
        let payload = {
            searchText: filterData?.searchText,
            statusRefId: [1, 2, 4, 5, 6],
            limit: 10,
            offset: filterData?.offset
        }
        dispatch(getProductListAction(payload))
    }


    useEffect(() => {
        if (filterData) {
            getProductListApi()
            setCheckRecords([])
        }
    }, [filterData])

    useEffect(() => {
        if (!pendingAuditRecordId || !productList?.length) return;
        const match = productList.find((row: any) => row?.productDetailsId === pendingAuditRecordId);
        if (match) {
            setProductData(match);
            setOpen(true);
            setPendingAuditRecordId(undefined);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pendingAuditRecordId, productList])

    const addProductTemp = {
        categoryId: "",
        coreCategoryId: null,
        subCategoryId: "",
        productName: "",
        mrp: null,
        minimumQuantity: null,
        isMultipleRecords: 1,
        size: 1,
        color: 1,
        vendorId: "",
        weight: null,
        purchaseDate: moment().format("YYYY-MM-DD"),
        salesType: 1,
        description: "",
        // Combo stock: 1 = Regular, 2 = Combo (fixed once created); comboItems
        // are the picked component lines, only sent on create.
        stockType: 1,
        comboItems: []
    }

    const updateMultipleInventoryTemp = {
        productDetailId: "",
        key: "",
        invoiceId: "",
        damagedCount: 0,
        soldCount: 0,
        scrapCount: 0,
        returnedToVendorCount: 0,
        isRTV: 0
    }

    const [addProductData, setAddProductData] = useState<any>(deepCopyFunction(addProductTemp));
    // Set at Save-time from the Edit Product sheet's Stock Adjustment field;
    // applied via adminAdjustStock AFTER the product save completes, since the
    // regular save also writes productDetails.minimumQuantity (see
    // StockHistoryLogService.adminAdjustStock) and would clobber the adjustment
    // if the two ran out of order.
    const [pendingAdjustment, setPendingAdjustment] = useState<any>(null);
    const [awaitingAdjustment, setAwaitingAdjustment] = useState(false);
    const [updateMultipleInventoryData, setUpdateMultipleInventoryData] = useState<any>(deepCopyFunction(updateMultipleInventoryTemp))

    // Phase 3.1b: categoryâ†’sub-category filtering and edit-mode sub-category
    // prepopulation now live inside AddProductSheet (derived from
    // categoryAndSubCategoryList). The antd-Form-driven versions were removed.

    useEffect(() => {
        if (open == true) {
            setAddProductbtDisabled(false)
            dispatch(vendorDropDownListAction())
        }
    }, [open])
    const inputRef = useRef<any>(null);

    const handleWheel = (e: any) => {
        if (inputRef.current === document.activeElement) {
            e.preventDefault();
        }
    };
    const handleFocus = () => {
        // Ensure that the input is focused when clicking on it
        if (inputRef.current !== null && inputRef.current !== undefined) {
            inputRef.current.focus();
        }
    };

    const addProductApi = () => {
        setSpinnerLoad(true);
        // Edit always sends the stored type (the API rejects a change).
        let stockType = productData ? (productData?.stockType ?? 1) : (addProductData?.stockType ?? 1);
        let payload = {
            productDetailId: productData ? productData?.productDetailsId : "",
            coreCategoryId: addProductData?.coreCategoryId,
            categoryId: addProductData?.categoryId,
            subCategoryId: addProductData?.subCategoryId,
            productName: addProductData?.productName,
            mrp: parseFloat(addProductData?.mrp),
            minimumQuantity: parseInt(addProductData?.minimumQuantity),
            weight: addProductData?.weight,
            // isMultipleRecords: parseInt(addProductData?.isMultipleRecords),
            isMultipleRecords: 1,
            size: addProductData?.size,
            color: addProductData?.color,
            vendorId: addProductData?.vendorId,
            purchaseDate: addProductData?.purchaseDate,
            salesType: addProductData?.salesType,
            description: addProductData?.description,
            stockType: stockType,
            comboItems: !productData && stockType == 2
                ? (addProductData?.comboItems || []).map((c: any) => ({
                    productDetailId: c?.productDetailId,
                    quantity: parseInt(c?.quantity)
                }))
                : []
        }

        // Edit Product's "No.of Item Count" is read-only — a nonzero Stock
        // Adjustment value there gets applied separately via adminAdjustStock
        // once this save completes (see the createProductOnload effect below).
        if (productData && addProductData?.stockAdjustmentQty) {
            let adjustmentQty = parseInt(addProductData.stockAdjustmentQty);
            if (!Number.isNaN(adjustmentQty) && adjustmentQty !== 0) {
                setPendingAdjustment({
                    productDetailId: productData?.productDetailsId,
                    operationType: adjustmentQty > 0 ? "ADMIN_STOCK_ADD" : "ADMIN_STOCK_REMOVE",
                    quantity: Math.abs(adjustmentQty),
                    remarks: addProductData?.stockAdjustmentRemarks || ""
                });
            }
        }

        dispatch(addProductAction(payload));
        setCreateProductOnload(true);
    }

    const updateProductStatusApi = (statusRefId: any, product: any) => {
        let statusRefIdSwitch;
        switch (statusRefId) {
            case 2: statusRefIdSwitch = "In Stock";
                break;
            case 5: statusRefIdSwitch = "Damaged";
                break;
            case 4: statusRefIdSwitch = "Returned";
                break;
            case 6: statusRefIdSwitch = "Stickering Completed";
                break;
            case 9: statusRefIdSwitch = "Scrap";
                break;
            default: statusRefIdSwitch = "Sold";
                break;
        }
        let productItem = [];
        productItem.push(product?.productItemId);

        let payload = {
            productItemId: productItem,
            isArray: arrayStatus,
            statusRefId: statusRefId,
            status: statusRefIdSwitch
        }
        dispatch(updateProductStatusAction(payload))
        setProductStatusOnload(true)
    }

    const multipleUpdateStatus = (key: any) => {
        let productItem: any = [];
        {
            (checkRecords || []).map((item: any) => {
                return (
                    productItem.push(item?.productItemId)
                )
            })
        }
        setSpinnerLoad(true);
        let payload = {
            productItemId: arrayStatus ? [] : productItem,
            isArray: arrayStatus,
            statusRefId: key,
            status: key == 5 ? "Damaged" : key == 2 ? "In Stock" : key == 4 ? "Returned" : key == 6 ? "Stickering Completed" : "Sold"
        }
        dispatch(updateProductStatusAction(payload))
        setProductStatusOnload(true);
    }

    const [updateMultipleInventoryOnload, setUpdateMultipleInventoryOnload] = useState(false);
    const updateMultipleInventoryApi = () => {
        let payload = {
            productDetailId: updateMultipleInventoryData?.productDetailId,
            productItemId: updateMultipleInventoryData?.productItemId,
            key: updateMultipleInventoryData?.key,
            invoiceId: updateMultipleInventoryData?.invoiceId,
            damagedCount: updateMultipleInventoryData?.damagedCount,
            soldCount: updateMultipleInventoryData?.soldCount,
            returnedToVendorCount: 1,
            isRTV: checkBoxRTV,
            scrapCount: updateMultipleInventoryData?.scrapCount

        }
        dispatch(updateMultipleInventoryAction(payload))
        setUpdateMultipleInventoryOnload(true);
    }

    useEffect(() => {
        if (updateMultipleInventoryOnload == true && updateMultipleInventory == false) {
            getMultipleInventoryDataApi(multiInventoryProduct)
            setUpdateMultipleInventoryOnload(false);
            setUpdateMultipleInventoryData(updateMultipleInventoryTemp)
            toast.success("Inventory updated successfully");
        }
    }, [updateMultipleInventoryOnload, updateMultipleInventory])

    const getMultipleInventoryCountApi = (productDetailId: any) => {
        let payload = {
            productDetailId: productDetailId
        }
        dispatch(getMultipleInventoryCountsAction(payload))
    }

    const getMultipleInventorySoldListApi = (productId: any) => {
        let payload = {
            productId: productId
        }
        dispatch(getMultipleInventorySoldListAction(payload))
    }

    const getMultipleInventoryDamagedListApi = (productId: any) => {
        let payload = {
            productId: productId
        }
        dispatch(getMultipleInventoryDamagedListAction(payload))
    }

    const getMultipleInventoryScrapListpi = (productId: any) => {
        let payload = {
            productId: productId
        }
        dispatch(getMultipleInventoryScrapListAction(payload))
    }

    useEffect(() => {
        if (productStatusOnload == true && updateProductStatusOnload == false) {
            getProductListApi()
            setCheckRecords([])
            setProductStatusOnload(false)
            toast.success("Product status updated successfully");
        }
    }, [productStatusOnload, updateProductStatusOnload])

    useEffect(() => {
        if (updateProductStatusOnload == false && updateSpinner) {
            setUpdateSpinner(false);
            setSpinnerLoad(false);
        }
    }, [updateProductStatusOnload, updateSpinner])


    const updateStickeringStatusApi = (product: any) => {
        let payload = {
            productItemId: product?.productItemId
        }
        dispatch(updateStickeringStatusAction(payload))
        setStickerStatusOnload(true)
    }

    const productHistoryApi = (product: any) => {
        let payload = {
            productItemId: product?.productItemId
        }
        dispatch(getProductHistoryAction(payload))
        setProductHistoryOnload(true)
    }

    useEffect(() => {
        if (stickerStatusOnload == true && updateStickeringStatusOnload == false) {
            getProductListApi()
            setStickerStatusOnload(false)
            toast.success("Sticker status updated successfully");
        }
    }, [stickerStatusOnload, updateStickeringStatusOnload])

    useEffect(() => {
        if (productHistoryOnload == true && getProductHistoryOnload == false) {
            setProductHistoryOnload(false)
            setProductHistoryOpen(true)
        }
    }, [productHistoryOnload, getProductHistoryOnload])

    useEffect(() => {
        if (createProductOnload == true && addProductOnload == false) {
            setCreateProductOnload(false);
            // createProduct_v2 answers with a message string — anything other
            // than "Created Successfully" is a validation error (e.g. a combo
            // item no longer has enough stock). Keep the sheet open and skip
            // any pending Stock Adjustment.
            if (typeof addProductResult === "string" && addProductResult !== "Created Successfully") {
                toast.error(addProductResult);
                setPendingAdjustment(null);
                setAddProductbtDisabled(false);
                setSpinnerLoad(false);
                return;
            }
            if (pendingAdjustment) {
                dispatch(adminAdjustStockAction(pendingAdjustment));
                setPendingAdjustment(null);
                setAwaitingAdjustment(true);
            } else {
                toast.success(productData ? "Stock updated successfully" : "Stock added successfully");
                setAddProductData(addProductTemp)
                getProductListApi()
                productClose()
                setSpinnerLoad(false);
            }
        }
    }, [createProductOnload, addProductOnload])

    useEffect(() => {
        if (awaitingAdjustment && !adminAdjustStockLoad) {
            setAwaitingAdjustment(false);
            if (adminAdjustStockData?.adminAdjustStock && adminAdjustStockData.adminAdjustStock !== "Updated Successfully") {
                toast.error(adminAdjustStockData.adminAdjustStock);
            } else {
                toast.success("Stock updated successfully");
            }
            setAddProductData(addProductTemp)
            getProductListApi()
            productClose()
            setSpinnerLoad(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [awaitingAdjustment, adminAdjustStockLoad])

    useEffect(() => {
        dispatch(categoryAndSubCategoryListAction(''));
        getReferenceDataApi(1)
        getReferenceDataApi(2)
        dispatch(getCoreCategoryMetaAction(''));
        dispatch(mrpListAction());
        dispatch(vendorDropDownListAction());
        setDamagedCollapse([]) //this is for to close the collapse in view in multiple page
        setScrapCollapse([])
        setCollapse([])
    }, [])

    const addProductColorAndSizeApi = (color: any, size: any, product: any) => {
        let payload = {
            productItemId: product.productItemId,
            colorRefId: color,
            sizeRefId: size
        }
        dispatch(updateProductItemColorAndSizeAction(payload))
        setChangeColorStatusOnload(true)
    }

    useEffect(() => {
        if (changeColorStatusOnload == true && updateProductColorAndSizeOnload == false) {
            getProductListApi()
            setChangeColorStatusOnload(false);
            toast.success("Color/Size updated successfully");
        }
    }, [changeColorStatusOnload, updateProductColorAndSizeOnload])

    const onChange = (item: any, e: any) => {
        setselectAllModal(false);
        setArrayStatus(0)
        if (e?.target?.checked == false) {
            setCheckRecords(checkRecords.filter((x: any) => x?.productId != item?.productId));
        }
        else {
            setCheckRecords([...checkRecords, item]);
        }
    }


    const selectAll = (e: any) => {
        setselectAllModal(true);
        if (e?.target?.checked == false) {
            setCheckRecords([]);
        } else {
            let checked: any = [];
            {
                (productList || []).map((item: any, index: any) => {
                    checked.push(item)
                })
            }
            setCheckRecords([...checked]);
        }
    }

    const styles = {
        width: "100px",
        overflow: "hidden",
        textOverflow: "ellipsis",
        textWrap: "nowrap"
    }

    const productNameStyles = {
        width: "100px",
        overflow: "hidden",
        textOverflow: "ellipsis",
        textWrap: "nowrap",
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center"
    }
    const productClose = () => {
        setOpen(false)
        setSpinnerLoad(true);
        // form.setFieldsValue({
        //     [`core_category`]: null,
        //     [`category`]: null,
        //     [`subCategory`]: null,
        //     [`productName`]: "",
        //     [`MRP`]: "",
        //     [`Item`]: null,
        //     [`size`]: 1,
        //     [`color`]: 1,
        //     [`purchaseDate`]: null
        // })
        // setAddProductData({
        //     ...addProductData,
        //     purchaseDate: null,
        //     isMultipleRecords: 0,
        //     categoryId: "",
        // })
        setAddProductData(addProductTemp)
        setProductData(null)
        setCopySource(null)
    }
    useEffect(() => {
        if (open == false) {
            setSpinnerLoad(false)
        }
    }, [open])

    // Copy: same fields Edit pre-fills (purchase date included), except the item
    // count, which is left blank — a copy is usually a new batch.
    const startCopy = (source: any) => {
        setProductData(null)
        setCopySource(source)
        setAddProductData({
            ...addProductTemp,
            coreCategoryId: Number(source?.coreCategoryId),
            categoryId: source?.categoryId,
            productName: source?.productName,
            subCategoryId: source?.subCategoryId,
            mrp: source?.mrp,
            minimumQuantity: null,
            weight: source?.weight,
            isMultipleRecords: source?.isMultipleRecords == 0 ? AppConstant?.one : AppConstant?.zero,
            size: source?.sizeRefId,
            color: source?.colorRefId,
            purchaseDate: source?.purchaseDate ? moment(source.purchaseDate) : addProductTemp.purchaseDate,
            salesType: source?.salesType,
            vendorId: source?.vendorId,
            description: source?.description,
            stockType: source?.stockType ?? 1,
            comboItems: []
        })
        if (Number(source?.stockType) === 2) {
            dispatch(getComboItemsAction({ productDetailId: source?.productDetailsId }))
        }
        setOpen(true)
    }

    // A copied combo's item lines arrive after the sheet opens.
    useEffect(() => {
        if (!copySource || Number(copySource?.stockType) !== 2) return
        if (getComboItemsFor !== copySource?.productDetailsId || !Array.isArray(getComboItemsData)) return
        setAddProductData((prev: any) => ({
            ...prev,
            comboItems: getComboItemsData.map((line: any) => ({
                productDetailId: line?.productDetailId,
                productId: line?.productId,
                productName: line?.productName,
                mrp: line?.mrp,
                availableCount: Number(line?.availableCount) || 0,
                quantity: String(line?.quantity ?? "1")
            }))
        }))
    }, [copySource, getComboItemsFor, getComboItemsData])

    const prePopulateForEdit = () => {
        setAddProductData({
            ...addProductData,
            coreCategoryId: Number(productData?.coreCategoryId),
            categoryId: productData?.categoryId,
            productName: productData?.productName,
            subCategoryId: productData?.subCategoryId,
            mrp: productData?.mrp,
            minimumQuantity: productData?.minimumQuantity,
            weight: productData?.weight,
            isMultipleRecords: productData?.isMultipleRecords == 0 ? AppConstant?.one : AppConstant?.zero,
            size: productData?.sizeRefId,
            color: productData?.colorRefId,
            purchaseDate: (productData?.purchaseDate != null || productData?.purchaseDate != undefined) ? moment(productData?.purchaseDate) : null,
            salesType: productData?.salesType,
            vendorId: productData?.vendorId,
            description: productData?.description,
            stockType: productData?.stockType ?? 1,
            comboItems: []
        })
    }

    const handleKeyPress = (e: any) => {
        if (e.key === "Tab") return true
        const charCheck = new RegExp("[0-9]");
        const pressedKey = String.fromCharCode(!e.charCode ? e.which : e.charCode);
        if ((e.ctrlKey === true && (e.keyCode === 86)) || e.keyCode === 190) {
            // Allow Ctrl+V (paste)
            return true;
        }
        if (!charCheck.test(pressedKey) && !(e.keyCode === 8 || e.keyCode === 46 || e.keyCode === 37 || e.keyCode === 39)) {
            e.preventDefault();
            return false;
        }
        else if (e.target.value.length === 12)
            return true
        else if (e.keyCode === 8 || e.keyCode === 46 || e.keyCode === 37 || e.keyCode === 39)
            return true
        else return false

    }

    const handleKeyPressItemCount = (e: any) => {
        if (e.key === "Tab") return true
        const charCheck = new RegExp("[0-9]");
        const pressedKey = String.fromCharCode(!e.charCode ? e.which : e.charCode);
        if (!charCheck.test(pressedKey) && !(e.keyCode === 8 || e.keyCode === 46 || e.keyCode === 37 || e.keyCode === 39)) {
            e.preventDefault();
            return false;
        }
        else if (e.target.value.length === 12)
            return true
        else if (e.keyCode === 8 || e.keyCode === 46 || e.keyCode === 37 || e.keyCode === 39)
            return true
        else return false

    }

    const handlePaste = (e: any) => {
        const pastedValue = e.clipboardData.getData('text');
        // Check if pasted value contains only numeric characters or a dot
        if (!/^\d*\.?\d*$/.test(pastedValue)) {
            e.preventDefault();
        }
    };

    useEffect(() => {
        if (open == true && productData) {
            prePopulateForEdit()
        }
    }, [open, productData])


    const newproductApi = () => {
        setAddProductbtDisabled(true)
        addProductApi()
    }

    const filterOption = (input: any, option: any) => {
        const inputValue = input.toLowerCase();
        const optionText = option.children.toLowerCase();
        return optionText.startsWith(inputValue);
    };

    const coreCategories = [{
        id: 1,
        name: "Women"
    },
    {
        id: 2,
        name: "Men"
    },
    {
        id: 3,
        name: "Boy"
    },
    {
        id: 4,
        name: "Girl"
    },
    {
        id: 5,
        name: "Born Baby"
    },
    {
        id: 6,
        name: "Stationary"
    },
    {
        id: 7,
        name: "Accessories"
    },
    {
        id: 8,
        name: "Common"
    }]

    const disabledDate = (current: any) => {
        // Disable dates that are before the current date
        return current && current > moment().endOf('day');
    };

    // Phase 3.1b: the antd <Drawer> + <Form> add/edit form is now AddProductSheet
    // (shadcn Sheet + FormSection). Validation is ported one-to-one; the form model
    // (addProductData) and submit dispatch (newproductApi) are unchanged.
    const addProduct = () => {
        return (
            <AddProductSheet
                open={open}
                onClose={() => productClose()}
                productData={productData}
                addProductData={addProductData}
                setAddProductData={setAddProductData}
                saveDisabled={addProductbtDisabled}
                onSubmit={() => newproductApi()}
                categoryList={categoryList}
                categoryAndSubCategoryList={categoryAndSubCategoryList}
                getCoreCategoryData={getCoreCategoryData}
                sizeList={sizeList}
                colorList={colorList}
                getVendorDropDownList={getVendorDropDownList}
                handleKeyPress={handleKeyPress}
                handleKeyPressItemCount={handleKeyPressItemCount}
                handlePaste={handlePaste}
            />
        )
    }

    useEffect(() => {
        if (product) {
            setBarcodeOpen(true);
        }
    }, [product])

    // useEffect(()=>{
    //     if(multiInventoryProduct){
    //         getMultipleInventoryCountApi()
    //         getMultipleInventorySoldListApi()
    //         getMultipleInventoryDamagedListApi()
    //     }
    // },[multiInventoryProduct])

    const getMultipleInventoryDataApi = (data: any) => {
        getMultipleInventoryCountApi(data?.productDetailsId)
        getMultipleInventorySoldListApi(data?.productId)
        getMultipleInventoryDamagedListApi(data?.productId)
        getMultipleInventoryScrapListpi(data?.productId)
        dispatch(getStockHistoryAction({ productDetailId: data?.productDetailsId, operationType: "STOCK_ADJUSTMENT", limit: 20, offset: 0 }))
    }

    const inventoryMenuProcess = (key: any, data: any) => {
        if (key == "1") {
            setProductData(data);
            setOpen(true)
        } else if (key == "2") {
            setProduct(data);
        } else if (key == "3") {
            updateProductStatusApi(6, data)
        } else if (key == "4") {
            updateProductStatusApi(5, data)
        } else if (key == "5") {
            updateProductStatusApi(2, data)
        } else if (key == "6") {
            updateProductStatusApi(4, data)
        } else if (key == "7") {
            productHistoryApi(data)
            setHistoryData(data)
        } else if (key == "8") {
            setProductDetailsClose(true)
            setMultiInventoryProduct(data)
            getMultipleInventoryDataApi(data)
        } else if (key == "9") {
            updateProductStatusApi(9, data)

        }
        else if (key == "10") {
            setAttachmentEntityId(data?.productItemId)
            getAttachment(data?.productItemId)
            setAttachmentDrawer(true);
        } else if (key == "11") {
            startCopy(data)
        }

    }

    const multipleUpdateChanges = (key: any) => {
        if (key == "1") {
            setOpen(true)
        } else if (key == "2") {
            multipleUpdateStatus(5)
        } else if (key == "3") {
            multipleUpdateStatus(2)
        } else if (key == "4") {
            multipleUpdateStatus(4)
        } else if (key == "5") {
            multipleUpdateStatus(6)
        }
        else if (key == "10") {
            // setAttachmentEntityId(data?.productId)
            setAttachmentDrawer(true);
            // getAttachment(data?.productItemId)
        }
    }
    // Phase 3.1c: the antd <Upload> customRequest bodies are now plain pick
    // handlers called by AttachmentSheet's dropzone (once per selected file);
    // the imgList/singleImg push + the upload effect below are unchanged.
    const onPickImage = (file: any) => {
        if (imgList?.length < 5) {
            const imageType = file?.name?.split('.');
            let extension = imageType?.[imageType.length - 1]?.toLowerCase();
            if (['png', 'jpg', 'jpeg'].includes(extension)) {
                const obj = {
                    previewImage: URL.createObjectURL(file),
                    file: file
                };
                setImgList((prev: any) => prev ? [...prev, obj] : [obj]);
                setSingleImg(obj);
            }
        } else {
            toast.error('Please select up to 5 images only.');
        }
    };

    const onPickVideo = (file: any) => {
        if (videoList?.length < 5) {
            let videoType = file?.name?.split('.');
            let extension = videoType?.[videoType.length - 1]?.toLowerCase();
            if (['mp4', 'mpeg', 'webm'].includes(extension)) {
                let obj = {
                    previewImage: URL.createObjectURL(file),
                    file: file
                }
                setVideoList((prev: any) => prev ? [...prev, obj] : [obj])
                setSingleImg(obj);
            }
        }
        else {
            toast.error(`Please Select 5 Images Only`);
        }
    };

    const imageUploadApi = (files: any, coverImage: any, isDeleted: any, isImageOrVideo: number) => {
        // let ImgData = files.map((item: any) => {
        let obj = {
            attachmentId: "",
            fileName: files?.file?.name,
            entityId: attachmentEntityId,
            fileUuid: files?.fileUuid,
            // coverImage: imgFileUuid == singleImg?.fileUuid ? 1 : 0,
            coverImage: imgList.length == 1 ? 1 : coverImage,
            isImageOrVideo: isImageOrVideo,
            mimeType: files?.mimeType ? files?.mimeType : files?.file?.name?.substring(files?.file?.name?.lastIndexOf('.')),
            fileSize: typeof files?.fileSize == "string" ? files?.fileSize : toMb(files?.file?.size),
            isDeleted: isDeleted
        }
        // return obj;
        // })
        let payload = {
            attachment: [obj]
        }
        dispatch(createOrUpdateAttachmentAction(payload))
    }

    const getAttachment = (productItemId: any) => {
        let payload = {
            entityId: productItemId
        }
        dispatch(getAttachmentAction(payload))
    }

    const uploadAttachmentAws = (type: number) => {
        // let files = imgList?.map((x: any) => x?.file);
        // if (files.length <= 5) {
        if (type == 1)
            uploadPhotoToAWS(singleImg, imageUploadApi, type)
        else
            uploadPhotoToAWS(singleImg, imageUploadApi, type)
        // setDataDrawer([]);
        // setImgList([])
        // }

    }

    useEffect(() => {
        if (isArrayNotEmpty(imgList))
            uploadAttachmentAws(1)

    }, [imgList]);

    useEffect(() => {
        if (isArrayNotEmpty(videoList))
            uploadAttachmentAws(2)

    }, [videoList])

    useEffect(() => {
        if (imageUpload && !createOrUpdateAttachmentLoad) {
            getAttachment(attachmentEntityId)
            setImageUpload(false)
            toast.success("Image removed successfully");
        }
    }, [imageUpload, createOrUpdateAttachmentLoad])

    // Phase 3.1c: attachment gallery/delete/cover handlers, lifted out of the old
    // uploadAttachment() render fn (now AttachmentSheet). Logic unchanged.
    const setImages = (data: any, value: number) => {
        deleteFileFromS3(data?.fileUuid, 1)
        setImgList(imgList?.filter((item: any) => data?.fileUuid != item?.fileUuid))
        imageUploadApi(data, 1, 1, 1)
        if (value == 0)
            setImageUpload(true)
    }

    const setVideos = (data: any, value: number) => {
        deleteFileFromS3(data?.fileUuid, 2)
        setVideoList(videoList?.filter((item: any) => data?.fileUuid != item?.fileUuid))
        imageUploadApi(data, 0, 1, 2)
        if (value == 0)
            setImageUpload(true)
    }

    const coverImage = (data: any, fileUuid: any) => {
        setImgFileUuid(fileUuid)
        imageUploadApi(data, 1, 0, 1)
    }
    let skeletonList: any = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
    const inventoryManagementTable = () => {
        // Phase 3.1a: the antd <Table> (4 column variants) is now rendered by the
        // shadcn InventoryStockTable. All handlers/state below are passed through
        // unchanged; the legacy `*Columns`/`*Menu` builders above are retained for
        // reference until the wizard/drawers (3.1bâ€“d) are migrated too.
        return (
            <InventoryStockTable
                products={productList}
                loading={productListOnload}
                sizeList={sizeList}
                colorList={colorList}
                completedSticker={completedSticker}
                downloadSticker={downloadSticker}
                instockSticker={instockSticker}
                checkRecords={checkRecords}
                onColorSize={(color: number, size: number, item: any) => addProductColorAndSizeApi(color, size, item)}
                onMenuAction={(key: string, item: any) => inventoryMenuProcess(key, item)}
                onToggleRow={(item: any, e: any) => onChange(item, e)}
                onToggleAll={(e: any) => selectAll(e)}
                pagination={{
                    page: productListPage?.currentPage || 1,
                    total: productListPage?.totalCount || 0,
                    onChange: onPageChange,
                }}
            />
        )
    }

    const [productHistoryOpen, setProductHistoryOpen] = useState(false);

    const closeDamagedStatus = (item: any) => {
        if (item?.data[0].scrapCount) {
            setScrapData(item)
        }
        else {
            updateMultipleInventoryStatus(4, item)
        }


        setModalDamaged(true)
    }

    // const closeScrapStatus = (item: any) => {
    //     setModalDamaged(true)

    // }

    const closeDamagedStatusConfirm = () => {
        setUpdateProduct(true)
        scrapData && updateMultipleInventoryStatus(7, scrapData)
        setModalDamaged(false)
    }

    const closeDamagedStatusCancel = () => {
        setModalDamaged(false)
    }





    useEffect(() => {
        if (updateProduct) {
            updateMultipleInventoryApi()
            setUpdateProduct(false)
        }
    }, [updateProduct])


    const popupOpen = (key: any, item: any) => {
        if (key == 6) {
            setScrapData(item)

        }
        else {
            updateMultipleInventoryStatus(key, item)
        }
        setModalOpen(true)
    }

    const closePopupByConfirm = () => {
        setUpdateProduct(true)
        setModalOpen(false)
        scrapData && updateMultipleInventoryStatus(6, scrapData)
    }
    const closePopupByCancel = () => {
        setModalOpen(false)
    }



    const updateMultipleInventoryStatus = (key: any, item: any) => {
        if (key == 0) {

        } else if (key == 1) {
            setUpdateMultipleInventoryData({
                ...updateMultipleInventoryData,
                key: "SOLD_TO_INSTOCK",
                productDetailId: multiInventoryProduct?.productDetailsId,
                invoiceId: item?.invoiceId,
                productItemId: multiInventoryProduct?.productItemId,
                damagedCount: 0,
                soldCount: 1
            })
            // setUpdateProduct(true)
        } else if (key == 2) {
            setUpdateMultipleInventoryData({
                ...updateMultipleInventoryData,
                key: "SOLD_TO_DAMAGED",
                productDetailId: multiInventoryProduct?.productDetailsId,
                invoiceId: item?.invoiceId,
                productItemId: multiInventoryProduct?.productItemId,
                damagedCount: 1,
                soldCount: 0
            })
            // setUpdateProduct(true)
        } else if (key == 3) {
            setUpdateMultipleInventoryData({
                ...updateMultipleInventoryData,
                key: "ADD_TO_DAMAGED",
                productDetailId: multiInventoryProduct?.productDetailsId,
                invoiceId: "",
                productItemId: multiInventoryProduct?.productItemId,
                soldCount: 0
            })
            setUpdateProduct(true)
            setAddDamagedStatus(false)
        } else if (key == 4) {
            setUpdateMultipleInventoryData({
                ...updateMultipleInventoryData,
                key: "REMOVE_FROM_DAMAGED",
                productDetailId: multiInventoryProduct?.productDetailsId,
                invoiceId: item?.invoiceId ? item?.invoiceId : "",
                productItemId: multiInventoryProduct?.productItemId,
                damagedCount: 1,
                soldCount: 0
            }
            )
            // setUpdateProduct(true)
        }
        else if (key == 5) {
            setUpdateMultipleInventoryData({
                ...updateMultipleInventoryData,
                key: "MARK_AS_RETURN_TO_VENDOR",
                productDetailId: multiInventoryProduct?.productDetailsId,
                invoiceId: item?.invoiceId ? item?.invoiceId : "",
                productItemId: multiInventoryProduct?.productItemId,
                damagedCount: 1,
                soldCount: 0,
                returnedToVendorCount: 1,
                isRTV: checkBoxRTV
            })
            setUpdateProduct(true)
        }
        else if (key == 6) {
            setUpdateMultipleInventoryData({
                ...updateMultipleInventoryData,
                key: "ADD_TO_SCRAP",
                productDetailId: multiInventoryProduct?.productDetailsId,
                invoiceId: scrapData?.invoiceId ? scrapData?.invoiceId : "",
                productItemId: multiInventoryProduct?.productItemId,
                damagedCount: 0,
                soldCount: 0,
                returnedToVendorCount: 0,
                isRTV: 0,
                scrapCount: updateMultipleInventoryData?.scrapCount ? updateMultipleInventoryData?.scrapCount : 1
            })
            setUpdateProduct(true)
            setAddScrapStatus(false)
            setScrapData(null)
        }
        else if (key == 7) {
            setUpdateMultipleInventoryData({
                ...updateMultipleInventoryData,
                key: "REMOVE_FROM_SCRAP",
                productDetailId: multiInventoryProduct?.productDetailsId,
                invoiceId: scrapData?.invoiceId ? scrapData?.invoiceId : "",
                productItemId: multiInventoryProduct?.productItemId,
                damagedCount: 0,
                soldCount: 0,
                returnedToVendorCount: 0,
                isRTV: 0,
                scrapCount: AppConstant?.one
            })
            setAddScrapStatus(false)
            setScrapData(null)
        }
    }

    const setCloseDrawer = () => {
        getProductListApi()
        setProductDetailsClose(false)
        setCollapse([])
        setDamagedCollapse([])
        setScrapCollapse([])
        setStockAdjustmentCollapse([])
    }



    const checkBoxDamaged = (item: any) => {
        if (checkBoxRTV == 1) {
            setCheckBoxRTV(0)
        }
        else {
            setCheckBoxRTV(1)
        }
        updateMultipleInventoryStatus(5, item)
    }



    return (
        <div className="mz h-full overflow-y-auto">
            <ApparelMenu selectedKey="1" />
            <InventoryToolbar
                title={"Inventory Management"}
                searchPlaceHolder={"Product ID/Product Name"}
                onAdd={() => setOpen(true)}
                totalPage={productListPage?.totalCount}
                multipleUpdateChanges={multipleUpdateChanges}
                setCompletedSticker={setCompletedSticker}
                completedSticker={completedSticker}
                setDownloadSticker={setDownloadSticker}
                downloadSticker={downloadSticker}
                checkRecords={checkRecords}
                setCheckRecords={setCheckRecords}
                filterStatus={filterData?.filterStatus}
                defaultSearchText={filterData?.searchText}
                getsearchTextdataList={getsearchTextdataList}
                getFilterStatusdataList={getFilterStatusdataList}
                mrpFilter={filterData?.mrp}
                mrpList={mrpList}
                getMrpFilterdataList={getMrpFilterdataList}
                vendorFilter={filterData?.vendorId}
                vendorList={getVendorDropDownList}
                getVendorFilterdataList={getVendorFilterdataList}
                categoryFilter={filterData?.categoryId}
                subCategoryFilter={filterData?.subCategoryId}
                categoryAndSubCategoryList={categoryAndSubCategoryList}
                getCategoryFilterdataList={getCategoryFilterdataList}
                getSubCategoryFilterdataList={getSubCategoryFilterdataList}
                stockTypeFilter={filterData?.stockType}
                getStockTypeFilterdataList={getStockTypeFilterdataList}
                setInstockSticker={setInstockSticker}
                selectAll={selectAll}
                setArrayStatus={setArrayStatus}
                selectAllModal={selectAllModal}
                updateSpinner={updateSpinner}
                setUpdateSpinner={setUpdateSpinner}
            />
            <div className="px-6 py-4">
                {inventoryManagementTable()}
                {addProduct()}
                <ProductHistorySheet
                    open={productHistoryOpen}
                    onClose={() => setProductHistoryOpen(false)}
                    historyData={historyData}
                    productHistoryData={productHistoryData}
                    historyDates={getHistoryDate}
                    sizeList={sizeList}
                    colorList={colorList}
                />
                <MultiInventorySheet
                    open={productDetailsClose}
                    onClose={() => setCloseDrawer()}
                    product={multiInventoryProduct}
                    counts={getMultipleInventoryCounts}
                    soldList={getMultipleInventory_soldList}
                    damagedList={getMultipleInventory_damagedList}
                    scrapList={getMultipleInventory_ScrapList}
                    stockAdjustmentList={stockAdjustmentList}
                    collapse={collapse}
                    setCollapse={setCollapse}
                    damagedCollapse={damagedCollapse}
                    setDamagedCollapse={setDamagedCollapse}
                    scrapCollapse={scrapCollapse}
                    setScrapCollapse={setScrapCollapse}
                    stockAdjustmentCollapse={stockAdjustmentCollapse}
                    setStockAdjustmentCollapse={setStockAdjustmentCollapse}
                    popupOpen={popupOpen}
                    modalOpen={modalOpen}
                    onModalConfirm={() => closePopupByConfirm()}
                    onModalCancel={() => closePopupByCancel()}
                    addDamagedStatus={addDamagedStatus}
                    setAddDamagedStatus={setAddDamagedStatus}
                    addScrapStatus={addScrapStatus}
                    setAddScrapStatus={setAddScrapStatus}
                    updateMultipleInventoryData={updateMultipleInventoryData}
                    setUpdateMultipleInventoryData={setUpdateMultipleInventoryData}
                    updateMultipleInventoryStatus={updateMultipleInventoryStatus}
                    closeDamagedStatus={closeDamagedStatus}
                    modalDamaged={modalDamaged}
                    onDamagedConfirm={() => closeDamagedStatusConfirm()}
                    onDamagedCancel={() => closeDamagedStatusCancel()}
                    onEdit={(row: any) => {
                        setCloseDrawer();
                        inventoryMenuProcess("1", row);
                    }}
                />
                <AttachmentSheet
                    open={attacmentDrawer}
                    onClose={() => {
                        setAttachmentDrawer(false)
                        setImgList([])
                        setVideoList([])
                        getProductListApi()
                    }}
                    showImage={!!showAttachment}
                    setShowImage={setShowAttachment}
                    showVideo={showVideoAttachment}
                    setShowVideo={setVideoShowAttachment}
                    imgList={imgList}
                    videoList={videoList}
                    attachmentImages={getAttachmentListImage}
                    attachmentVideos={getAttachmentListVideo}
                    addCoverImage={addCoverImage}
                    setAddCoverImage={setAddCoverImage}
                    imgFileUuid={imgFileUuid}
                    onPickImage={onPickImage}
                    onPickVideo={onPickVideo}
                    onRemoveImage={setImages}
                    onRemoveVideo={setVideos}
                    onSetCoverImage={coverImage}
                />

                <BarCode product={product} open={barcodeOpen} setOpen={setBarcodeOpen} setProduct={setProduct} />
            </div>
            <LoadingOverlay loading={spinnerLoad} />
        </div>
    )
}


export default InventoryManagement
